import React from "react";
import Button from "./Button";

/**
 * PrimaryButton - Blue button for primary actions
 * 
 * Use for: Submit, Save, Approve, Create, Release, Update, Confirm
 * 
 * @example
 * <PrimaryButton onClick={handleSubmit} loading={isSubmitting}>
 *   Submit
 * </PrimaryButton>
 */
const PrimaryButton = (props) => {
  return <Button variant="primary" {...props} />;
};

export default PrimaryButton;

